import React from 'react';
import Header from '../components/header/HeaderOne';
import Footer from '../components/footer/FooterOne';

import Breadcrumb from '../components/sections/Breadcrumb';

import FaqSecThree from '../components/sections/FaqSecThree';
import ContactSecOne from '../components/sections/ContactSecOne';

const Faq = () => {
  return (
    <>
      <Header />
        <Breadcrumb titleKey="sections.breadcrumb.faq.title" subtitleKey="sections.breadcrumb.faq.subtitle" />
        <FaqSecThree className="space overflow-hidden" />
        <ContactSecOne className="space overflow-hidden" />
        
      <Footer />
    </>
  );
};

export default Faq;